import React from 'react';
import {
  Paper,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { useBuild } from '../contexts/BuildContext';
import PolymarketStoryCard from './polymarket/PolymarketStoryCard';
import KalshiStoryCard from './kalshi/KalshiStoryCard';
import TokenItemsStoryCard from './token_items/TokenItemsStoryCard';

const StoriesResultsColumn = () => {
  const { storiesResults, isLoading, storiesEngine } = useBuild();

  // Mapping from engine to rendering component
  const storyRenderers = {
    polymarket_v1: PolymarketStoryCard,
    polymarket_v2: PolymarketStoryCard,
    kalshi_v1: KalshiStoryCard,
    token_items_v1: TokenItemsStoryCard,
  };

  const getStoryRenderer = () => {
    return storyRenderers[storiesEngine] || null;
  };

  const renderContent = () => {
    // Show loading indicator while fetching
    if (isLoading) {
      return (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          gap: 2,
        }}>
          <CircularProgress />
          <Typography variant="body2" color="text.secondary">
            Generating stories...
          </Typography>
        </Box>
      );
    }

    // Show empty state when no results yet
    if (!storiesResults) {
      return (
        <Typography variant="body2" color="text.secondary">
          No stories generated yet. Execute a query to see results here.
        </Typography>
      );
    }

    const StoryComponent = getStoryRenderer();
    
    // If we have a renderer for this engine, use it
    if (StoryComponent && storiesResults.stories) {
      return (
        <Box>
          {storiesResults.stories.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No stories found.
            </Typography>
          ) : (
            storiesResults.stories.map((story, index) => (
              <StoryComponent key={index} story={story} />
            ))
          )}
        </Box>
      );
    }

    // Fallback to JSON display
    return (
      <Box
        component="pre"
        sx={{
          bgcolor: 'background.paper',
          p: 2,
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'auto',
          fontFamily: 'monospace',
          fontSize: '0.875rem',
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
        }}
      >
        {JSON.stringify(storiesResults, null, 2)}
      </Box>
    );
  };

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h6" gutterBottom>
        Results
      </Typography>
      <Box sx={{ mt: 2, flex: 1, overflow: 'auto' }}>
        {renderContent()}
      </Box>
    </Paper>
  );
};

export default StoriesResultsColumn;

